import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {Map} from 'immutable';
import config from 'config';
import ReactModal from 'react-modal';
import Box from 'components/box';
import Spinner from 'spinner';
import {Error} from 'components/errors';
import Upload from 'components/upload';
import {PageHead } from 'components/header/components';
import {DocumentWarning} from 'components/documents';
import styled from 'styled-components';
import {Modal, CloseModal, ModalContent} from 'components/modal';
import {ButtonSuccess, ButtonDanger, ButtonSuccessModal, ButtonDangerModal, ButtonWrap} from 'components/buttons';
import { path, not, equals, gt } from 'ramda';

import {MailInformation} from './detail/mail-information';
import {MailActions} from './detail/mail-actions';
import {DocumentInformation} from './detail/document-information';
import Textarea from 'form/textarea';

import close from 'images/general/close.svg';

import {loadMailDetail, loadMailUsersOperator, loadMailJournal, deleteMail, attachFile, sendMailAnswer, changeMailComment, cleanMailStore, sendMailUsersOperatorSuccess} from 'redux/actions/admin/mailing';
import {loadUser} from 'redux/actions/auth';

const ErrorBlock = styled(Error)`
  color: rgb(218,156,21);
  position: absolute;
  top: 75%;

  @media screen and (max-width: 600px) {
    font-size: 12px;
    top: 63%;
  }
`

const Form = styled.form`
  position: relative;
`

const mapStateToProps = (state) => ({
  mail: state.adminMails.get('mailDetail'),
  users: state.adminMails.get('mailUsers'),
  journal: state.adminMails.get('mailJournal'),
  comment: state.adminMails.get('mailComment'),
  isFetching: state.adminMails.get('mailsAreLoading'),
  token: state.auth.get('token'),
  user: state.auth.get('user'),
  sendFail: state.adminMails.get('sendMailOperatorFail'),
  sendSuccess: state.adminMails.get('sendMailOperatorSuccess'),
  isSubmitting: state.adminMails.get('sendMailOperatorSubmitting')
});

const mapDispatchToProps = (dispatch) => ({
  onLoad: (id) => {
    dispatch(loadMailUsersOperator(id));
    dispatch(loadMailDetail(id));
    dispatch(loadMailJournal(id));
  },
  attachFile: file => dispatch(attachFile(file)),
  deleteMail: (id) => dispatch(deleteMail(id)),
  changeComment: (event) => dispatch(changeMailComment(event.target.value)),
  sendMailAnswer: (mail_id, id) => dispatch(sendMailAnswer(mail_id, id)),
  loadUser: () => dispatch(loadUser()),
  sendMailUsersOperatorSuccess: () => dispatch(sendMailUsersOperatorSuccess(false)),
  cleanMailStore: () => dispatch(cleanMailStore())
});

class MailDetail extends Component {

  state = {
    modalOpen: false,
    modalAnswer: false,
    error: false,
    errorMsg: '',
    fileError: false,
    fileErrorMsg: ''
  };

  toggleModal = () => this.setState({ modalOpen: !this.state.modalOpen });

  toggleModalAnswer = () => {
    this.removeError()
    this.removeFileError()
    this.props.cleanMailStore()
    this.setState({ modalAnswer: !this.state.modalAnswer });
  }

  onSubmitForm = event => {
    event.preventDefault()
    if(!this.props.comment) {
      this.generateError('Будь ласка, введіть коментар')
      return
    } else if (this.state.fileError) {
      return
    }
    this.props.sendMailAnswer(this.props.users.getIn(['results', 0, 'id']), this.props.match.params.mail_id)
  }

  generateError = msg => this.setState(()=> ({ error: true, errorMsg: msg }))
  generateFileError = msg => this.setState(()=> ({ fileError: true, fileErrorMsg: msg }))

  renderError = () => this.state.error && <ErrorBlock>{this.state.errorMsg}</ErrorBlock>

  renderFileError = () =>
    (this.state.fileError && !this.state.error) && <ErrorBlock>{this.state.fileErrorMsg}</ErrorBlock>

  removeError = () => this.setState(() => ({ error: false, errorMsg: '' }))
  removeFileError = () => this.setState(() => ({ fileError: false, fileErrorMsg: '' }))

  loadFile = (file, name, size) => {
    const maxSize = 16000000
    const type = path(['type'], file)
    if(type && not(equals(type, 'application/pdf'))) {
      this.generateFileError('Вибраний файл не в форматі pdf')
    } else if (gt(size, maxSize)){
      this.generateFileError('Вибраний файл більше ніж 16 мб')
    } else {
      this.removeFileError()
      this.props.attachFile(file)
    }
  }

  componentDidMount() {
    this.props.onLoad(this.props.match.params.mail_id);
  }

  componentWillReceiveProps (nextProps) {
    if(nextProps.sendFail) {
      const fileError = path(['file', 0], nextProps.sendFail)

      if(fileError && fileError.indexOf('Ensure this filename has at most 100 characters') > -1) {
        this.generateFileError('Назва файлу має містити не більше ніж 100 символів')
      } else {
        this.generateError('Виникла помилка при збереженні відповіді')
      }

    } else if (nextProps.sendSuccess) {
      this.toggleModalAnswer()
      this.props.sendMailUsersOperatorSuccess(false)
    }
  }

  componentWillUnmount () {
    this.props.cleanMailStore()
  }

  render() {

    if (!this.props.mail || !this.props.journal || !this.props.users || !this.props.users.get('results') || !this.props.user) return <Spinner/>;

    if (this.props.isFetching || this.props.isSubmitting) return <Spinner/>;

    const mail = this.props.mail;

    return (
      <div>
        <PageHead>
          <h2>{mail.getIn(['document_list', 0]) === undefined ? "Розсилка" : mail.getIn(['document_list', 0, 'document_data', 'name'])}</h2>
        </PageHead>
        <Box title4="Дії з розсилкою">
          {!(this.props.users.getIn(['results', 0, 'status'])) ? (
            <MailActions
              isAnswered={this.props.users.getIn(['results', 0, 'status'])}
              toggleModalAnswer={this.toggleModalAnswer}
              id={this.props.match.params.mail_id}/>
          ):(
            <div>
              <span style={{color: "#398439", fontSize: "16px"}}>Ви вже відповіли на цю розсилку</span>
              <p style={{
                "marginTop": "10px"
              }}>Відповідь: <strong>{this.props.users.getIn(['results', 0, 'comment'])}</strong></p>

              <p style={{marginTop: "10px"}}>
                <span>Документ:</span>
                {this.props.users.getIn(['results', '0', 'file'])
                  ? <a style={{marginLeft: "5px"}} href={this.props.users.getIn(['results', '0', 'file'])} target="_blank"><i className="fa fa-file-text-o" aria-hidden="true"></i></a>
                  : <strong> документ відсутній</strong>}
              </p>
              <p style={{
                "marginTop": "10px"
              }}>Дата відповіді: <strong>{new Date(this.props.users.getIn(['results', 0, 'status'])).toLocaleString('uk-UA', config.options)}</strong></p>
            </div>
          )

          }
        </Box>
        <Box title4="Основні дані">
          <MailInformation mail={mail} />
        </Box>

        {mail.get('document_list').get(0) === undefined ? (
          null
        ):(
          <Box title4="Дані про документ">
            <DocumentInformation document={mail.get('document_list').get(0).get('document_data')}/>
          </Box>
        )}


        <ReactModal isOpen={this.state.modalAnswer} onRequestClose={this.toggleModalAnswer}
          className={{
            base: 'modalContent',
            afterOpen: 'myClass_after-open',
            beforeClose: 'myClass_before-close'
          }} contentLabel="Підтвердження запису"
          overlayClassName={{
            base: 'modalOverlay',
            afterOpen: 'myOverlayClass_after-open',
            beforeClose: 'myOverlayClass_before-close'
          }}>

          <Modal>
            <CloseModal>
              <div>
                 <img src={close} alt="закрити" onClick={this.toggleModalAnswer} />
              </div>
						</CloseModal>
            <ModalContent>
              <h3>Відповідь на розсилку</h3>
              <Form onSubmit={this.onSubmitForm}>
                <Textarea
                  label="Коментар:"
                  required
                  max={511}
                  placeholder="Введіть коментар"
                  value={this.props.comment}
                  onChange={this.props.changeComment}
                  onFocus={this.removeError}
                />
                <Upload
                  accept=".pdf"
                  label="Прикріпити документ"
                  onChange={this.loadFile}
                />
                <DocumentWarning>
                  Можна завантажувати лише файли в форматі <strong>.pdf</strong>
                </DocumentWarning>

                {this.renderError()}
                {this.renderFileError()}

                <ButtonWrap>
                  <ButtonSuccess type="submit" value="Підтвердити"/>
                  <ButtonDanger value="Закрити" onClick={this.toggleModalAnswer}/>
                </ButtonWrap>
              </Form>
            </ModalContent>
          </Modal>

        </ReactModal>


        <ReactModal isOpen={this.state.modalOpen} onRequestClose={this.toggleModal}
          className={{
            base: 'modalContent',
            afterOpen: 'myClass_after-open',
            beforeClose: 'myClass_before-close'
          }} contentLabel="Підтвердження запису"
          overlayClassName={{
            base: 'modalOverlay',
            afterOpen: 'myOverlayClass_after-open',
            beforeClose: 'myOverlayClass_before-close'
          }}>

          <div>
            <Modal>
              <CloseModal>
                <div>
  				         <img src={close} alt="закрити" onClick={this.toggleModal} />
                </div>
  						</CloseModal>
              <ModalContent>
                <h3>Ви впевнені, що хочете видалити документ?</h3>

                <ButtonWrap>
                  <ButtonSuccessModal onClick={(id) => this.props.deleteDocument(this.props.match.params.document_id)} value="Так"/>
                  <ButtonDangerModal value="Ні" onClick={this.toggleModal}/>
                </ButtonWrap>
              </ModalContent>
            </Modal>
          </div>

        </ReactModal>
      </div>
    )
  }
}

MailDetail.propTypes = {
  mail: PropTypes.instanceOf(Map),
  onLoad: PropTypes.func.isRequired
};

export default connect(mapStateToProps, mapDispatchToProps)(MailDetail);



// WEBPACK FOOTER //
// ./src/operator/mailing/detail.js